import { useMemo } from 'react';
import { createBreadcrumbsPath } from '../data/breadCrumbs';
import { useResetHomeState } from './useNavigateHome';

export const useBreadcrumbs = () => {
  const resetHomeState = useResetHomeState();

  const homeBreadcrumb = useMemo(() => createBreadcrumbsPath(resetHomeState), [resetHomeState]);

  return { homeBreadcrumb };
};
